export default "__VITE_ASSET__e4dd943a__"